// event-listeners.js - Sets up event listeners for UI components

import store from './store.js';
import { toggleTheme } from './theme.js';
import { createNewConversation } from './conversations.js';
import { 
    hideLogoutConfirmation, 
    showLogoutConfirmation, 
    hideLearnMore,
    showLearnMore, 
    hideWalletModal,
    showWalletModal,
    performLogout
} from './authentication.js';
import { setupMessageMenus, setupMessageHandling } from './messages.js';
import { closeQrCodeModal } from './ui.js';

/**
 * Set up the event listeners for the application
 */
function setupEventListeners() {
    // Débogage pour détecter le problème de double appel
    console.log("Setting up event listeners");
    
    // Message handling - s'assurer qu'il est configuré une seule fois
    setupMessageHandling();
    
    // Theme toggle
    const themeToggle = document.getElementById("themeToggle");
    if (themeToggle) themeToggle.addEventListener("click", toggleTheme);

    // New chat button
    const newChatBtn = document.getElementById("newChatBtn");
    if (newChatBtn) newChatBtn.addEventListener("click", createNewConversation);

    // Logout button 
    const logoutBtn = document.getElementById("logoutBtn");
    if (logoutBtn) logoutBtn.addEventListener("click", showLogoutConfirmation);

    // Logout confirmation buttons
    const logoutCancelBtn = document.getElementById("logoutCancelBtn");
    if (logoutCancelBtn) logoutCancelBtn.addEventListener("click", hideLogoutConfirmation);
    
    const logoutConfirmBtn = document.getElementById("logoutConfirmBtn");
    if (logoutConfirmBtn) logoutConfirmBtn.addEventListener("click", performLogout);

    // Login learn more link
    const loginLearnMoreLink = document.getElementById("loginLearnMoreLink");
    if (loginLearnMoreLink) {
        loginLearnMoreLink.addEventListener("click", (e) => {
            e.preventDefault();
            showLearnMore();
        });
    }

    // Connect wallet button
    const connectWalletBtn = document.getElementById("connectWalletBtn");
    if (connectWalletBtn) {
        connectWalletBtn.addEventListener("click", showWalletModal);
    }

    // Close wallet modal button
    const closeWalletModalBtn = document.getElementById("closeWalletModalBtn");
    if (closeWalletModalBtn) {
        closeWalletModalBtn.addEventListener("click", hideWalletModal);
    }
    
    // Close QR code modal button
    const closeQrCodeBtn = document.getElementById("closeQrCodeBtn");
    if (closeQrCodeBtn) {
        closeQrCodeBtn.addEventListener("click", closeQrCodeModal);
    }

    // Set up confirm modal event listeners
    setupConfirmModal();

    // Set up message menu event listeners
    setupMessageMenus();
}

/**
 * Set up confirm modal event listeners
 */
function setupConfirmModal() {
    const confirmCancel = document.getElementById("confirmCancel");
    const confirmOk = document.getElementById("confirmOk");
    const confirmModal = document.getElementById("confirmModal");

    if (confirmCancel) {
        confirmCancel.addEventListener("click", () => {
            if (confirmModal) confirmModal.style.display = "none";
            const callback = store.confirmCallback;
            if (callback) callback(false);
        });
    }

    if (confirmOk) {
        confirmOk.addEventListener("click", () => {
            if (confirmModal) confirmModal.style.display = "none";
            const callback = store.confirmCallback;
            if (callback) callback(true);
        });
    }
}

export { setupEventListeners };